/**
 * PortalEventSymbol.js
 *
 * Copyright (c) apploft. GmbH
 */

const authorize = Symbol('request access');
const authorizeCallback = Symbol('process callback');
const authorizationFailed = Symbol('authorization failed');
const authorizationSucceeded = Symbol('authorization succeeded');

export {authorize, authorizeCallback, authorizationFailed, authorizationSucceeded};
